var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvLayoutBottomLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 140,
    viewBox: "0 0 139 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2118_112259",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 139,
    height: 140
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.738281 0.705078H138.605V139.612H0.738281V0.705078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2118_112259)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2118_112259",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 161,
    height: 157
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4791 0.964844L161.893 24.3301L137.803 156.137L1.38867 132.766L25.4791 0.964844Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2118_112259)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2118_112259",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 137,
    height: 157
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.746 156.125L1.38867 132.766L25.4791 0.964844L137.746 156.125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2118_112259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4791 0.964844L161.893 24.3301L137.803 156.137L1.38867 132.766L25.4791 0.964844Z",
    fill: "#009CDF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvLayoutBottomLight);
export default __webpack_public_path__ + "static/media/adv-layout-bottom-light.01fb3360ff8cd0ab10f850fdc22b02f4.svg";
export { ForwardRef as ReactComponent };